import React, {FC} from 'react';
import {IProductSection} from 'modules/products/types';
import {useRouter} from 'next/router';

export const FlocktoryCategoryView: FC<{
    categoryId: IProductSection['id'];
}> = ({categoryId}) => {
    const {pathname} = useRouter();
    return (
        <div
            className={'i-flocktory'}
            data-fl-action={'track-category-view'}
            data-fl-category-id={'/catalog/[...slug]' === pathname ? categoryId : 0}
        />
    );
};

export default FlocktoryCategoryView;
